import React from "react"
import { PesquisaSatisfacaoFornecedorContextProvider } from "./context/PesquisaSatisfacaoFornecedorContextProvider"
import { PesquisaSatisfacaoFornecedor } from "./PesquisaSatisfacaoFornecedor"

export function Index() {
    return (
        <PesquisaSatisfacaoFornecedorContextProvider>
            <PesquisaSatisfacaoFornecedor />
        </PesquisaSatisfacaoFornecedorContextProvider>
    )
}
